import { IMAGES } from "../constants/images";
import Sidebar from "../components/Sidebar";
import { useUser } from "../contexts/UserContext";
import useMoveTo from "../constants/navigation";
import { ROUTES } from "../App";
import MobileHeader from "../components/MobileHeader";


const Store = () => {
    const navigate = useMoveTo();
    const { currentUser } = useUser();

    // Helper to get the right route based on login
    const getRoute = (type) => {
        if (currentUser) {
            // Logged-in users go to actual store pages
            switch (type) {
                case "courses":
                    return ROUTES.STORE_COURSES;
                default:
                    return `${ROUTES.STORE_PRODUCTS}/${type}`;
            }
        } else {
            // Guests go to preview pages
            switch (type) {
                case "courses":
                    return ROUTES.PREVIEW_STORE_COURSES;
                default:
                    return `${ROUTES.PREVIEW_STORE_PRODUCTS}/${type}`;
            }
        }
    };


    return (
        <div className="flex flex-col h-screen bg-white text-black dark:bg-[#1A1A1A] dark:text-white overflow-hidden">
            {/* Mobile Header */}
            <MobileHeader title="Library"
                rightElement={
                    <button
                        onClick={() => navigate(ROUTES.MY_LIBRARY)}
                        className={`px-4 py-2 text-xs rounded-md font-semibold transition border border-[#327691] bg-[#327691] text-white dark:text-white}`}
                    >
                        My Library
                    </button>
                } />


            <div className="flex flex-1 overflow-hidden">
                {/* Sidebar */}
                <Sidebar />

                {/* Main Content */}
                <main className="flex-1 overflow-y-auto pt-5 pb-24 md:pb-5 px-6 bg-white text-black dark:bg-[#1A1A1A] dark:text-white">
                    <div
                    >
                        {/* Top Header */}

                        <div className="items-center justify-between pb-4 hidden md:flex">
                            <h2 className="text-xl md:text-3xl font-semibold mb-4">Library</h2>
                            <div className="w-5 md:hidden block" />
                            <button
                                onClick={() => navigate(ROUTES.MY_LIBRARY)}
                                className={`px-4 py-2 rounded-xl font-semibold transition border border-[#327691] bg-[#327691] text-white dark:text-white}`}
                            >
                                My Library
                            </button>
                        </div>


                        {/* Store Content */}
                        {/* Store Product Cards */}
                        <div className="flex flex-col items-center justify-center h-full">
                            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-8 w-full h-full max-w-full">
                                {/* Card Template */}
                                {[
                                    { name: "Courses", img: IMAGES.courses, type: "courses" },
                                    { name: "LUTs", img: IMAGES.luts, type: "LUTs" },
                                    { name: "E-Guides", img: IMAGES.eGuides, type: "E-Guides" },
                                    { name: "SFX", img: IMAGES.sfx, type: "SFX" },
                                    { name: "Presets", img: IMAGES.presets, type: "Presets" },
                                    { name: "E-Books", img: IMAGES.eBooks, type: "E-Books" },
                                ].map((item, i) => (
                                    <div
                                        key={i}
                                        onClick={() => navigate(getRoute(item.type))}
                                        className="flex flex-col items-center justify-center cursor-pointer"
                                    >
                                        <div className="relative flex flex-col items-center justify-center rounded-2xl shadow-lg transition-all duration-300 bg-[#F5F9FE] dark:bg-white text-black border border-gray-200 dark:border-0 hover:scale-105 w-full h-[19vh] sm:h-[25vh] md:h-[28vh] lg:h-[35vh]">
                                            <img
                                                src={item.img}
                                                alt={item.name}
                                                className="w-[5rem] sm:w-[6rem] md:w-[8rem] lg:w-[10rem] object-contain mb-2"
                                            />
                                        </div>
                                        <span className="mt-2 sm:mt-4 text-sm sm:text-base md:text-lg font-semibold text-black dark:text-white">
                                            {item.name}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </main>
            </div>
        </div>
    );
}

export default Store;
